export abstract class ILogger {
  public isEnabled: boolean;
  // User tracking
  public abstract setUser(identifier: string, email: string): void;
  public abstract resetUser(): void;
  // Track Router changes
  public abstract navigation(path: string);
  // Track Errors
  public abstract exception(error: Error, optionalProperties?: any);
  // Track redux actions
  public abstract action<T>(actionType: string, payload: T);

  public abstract debug(message: any, ...optionalParameters: any[]): void;
  public abstract info(message: any, ...optionalParameters: any[]): void;
  public abstract warn(message: any, ...optionalParameters: any[]): void;
  public abstract error(message: any, ...optionalParameters: any[]): void;
}
